<template>
	<tr class="no-click">
		<td>{{ source.target.name }}</td>
		<td>{{ source.planned_amount }}</td>
		<td>
			<v-form ref="form" v-model="valid">
				<v-text-field
					v-model="amount"
					class="mt-4 append-outer"
					label="消費量"
					:rules="[rules.required, rules.float]"
					dense
					outlined
				>
					<template v-slot:append-outer>
						<v-btn
							color="secondary"
							@click="submitForm()"
							:disabled="!valid || status == 'completed'"
						>
							保存
						</v-btn>
					</template>
				</v-text-field>
			</v-form>
		</td>
	</tr>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import rules from "../../../helper/rules"

export default {
	props: {
		source: {
			type: Object,
			required: true,
		},
		status: {
			type: String,
		},
	},
	data() {
		return {
			valid: false,
			amount: this.source.amount,
			rules,
			common,
		}
	},
	methods: {
		submitForm() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/rubber_process_sources/${this.source.id}`
			const params = {
				rubber_process_source: {
					amount: this.amount,
				},
			}
			axios
				.put(url, params, { headers })
				.then((res) => {
					this.$emit("update-source", res.data)
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: `消費量を保存しました`,
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>

<style></style>
